// Onboarding helpers — all state kept in localStorage (frontend-only, no backend).
// Keeping this isolated makes it easy to add/remove onboarding features later.

export const LS_KEYS = {
  welcomeSeen: 'mb_onboarding_welcome_seen',
  gettingStartedDismissed: 'mb_getting_started_dismissed',
  whatsNewCircles: 'mb_whatsnew_circles_dismissed',
  seenInsights: 'mb_seen_insights',
};

export const lsGet = (k) => {
  try { return localStorage.getItem(k); } catch { return null; }
};
export const lsSet = (k, v) => {
  try { localStorage.setItem(k, v); } catch { /* ignore */ }
};

export const hasSeenWelcome = () => lsGet(LS_KEYS.welcomeSeen) === '1';
export const markWelcomeSeen = () => lsSet(LS_KEYS.welcomeSeen, '1');

export const isGettingStartedDismissed = () => lsGet(LS_KEYS.gettingStartedDismissed) === '1';
export const dismissGettingStarted = () => lsSet(LS_KEYS.gettingStartedDismissed, '1');

export const isWhatsNewCirclesDismissed = () => lsGet(LS_KEYS.whatsNewCircles) === '1';
export const dismissWhatsNewCircles = () => lsSet(LS_KEYS.whatsNewCircles, '1');

export const hasSeenInsights = () => lsGet(LS_KEYS.seenInsights) === '1';
export const markInsightsSeen = () => lsSet(LS_KEYS.seenInsights, '1');

// ── Demo (example) receipt — shown so new users can SEE the payoff before
// scanning anything. It is never saved and never hits the backend. ──────────
export const DEMO_RECEIPT = {
  id: 'demo-example',
  merchant: 'Tesco',
  currency: 'GBP',
  symbol: '£',
  category: 'Groceries',
  store: 'Tesco Superstore, High Street',
  receiptNo: 'TSC-4471-0098',
  paymentMethod: 'Visa Debit ****4021',
  items: [
    { name: 'Semi-Skimmed Milk 2.27L', qty: 1, price: 1.45 },
    { name: 'Free Range Large Eggs (12)', qty: 1, price: 2.75 },
    { name: 'Hovis Wholemeal Bread 800g', qty: 1, price: 1.20 },
    { name: 'Bananas Loose (approx 5)', qty: 1, price: 0.72 },
    { name: 'Chicken Breast Fillets 650g', qty: 1, price: 4.50, clubcard: true },
    { name: 'Cathedral City Cheddar 350g', qty: 1, price: 3.25, clubcard: true },
    { name: 'Cherry Tomatoes 330g', qty: 1, price: 0.99 },
    { name: 'Heinz Baked Beans 4x415g', qty: 1, price: 2.90 },
  ],
  subtotal: 17.76,
  savings: 2.10,
  total: 15.66,
};

// A recent-looking date string for the demo receipt (2 days ago).
export const demoReceiptDate = () => {
  const d = new Date();
  d.setDate(d.getDate() - 2);
  return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
};
